import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Mode } from '@bingads-webui-react/app-layout-container';
import type { IChangeLayoutFn } from '@bingads-webui-react/app-layout-container';

import { SidePanelContainer } from './side-panel-container';

const getStyles = () => ({
  container: {
    position: 'relative',
    height: '100%',
  },
});

export interface SidePanelLayoutContainerProps {
  changeLayout: IChangeLayoutFn;
}

export const SidePanelLayoutContainer = (props: SidePanelLayoutContainerProps) => {
  const classes = useDefaultStyles(getStyles);
  const { changeLayout } = props;

  const showPanelContainer = useCallback((expanded: boolean) => {
    const mode = expanded ? Mode.Expanded : Mode.Hidden;
    changeLayout({ panelContainer: { mode } });
  }, [changeLayout]);

  return (
    <SidePanelContainer
      className={classes.container}
      showPanelContainer={showPanelContainer}
    />
  );
};

SidePanelLayoutContainer.propTypes = {
  changeLayout: PropTypes.func.isRequired,
};
